module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921045649_T.53c5f7bc.jpg";